import { LoadingModalWithLock } from "@/components/loading-modals/LoadingModalWithLock";
import { usePrompt } from "@/hooks/usePrompt";
import { Indent, Row } from "@stenajs-webui/core";
import { PrimaryButton, SecondaryButton } from "@stenajs-webui/elements";
import * as React from "react";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { StoreState } from "@/redux/RootReducer";
import { getExpectedVolumeChanges } from "../lib/ChangesCollector";
import { expectedVolumeTableReset } from "../redux/thunks/ExpectedVolumeTableReset";

interface Props {
  onSave: () => void;
  saving: boolean;
}

const selector = (state: StoreState) =>
  state.expectedVolume.expectedVolumesByRoutePair;

export const ExpectedVolumeActionButtons: React.FC<Props> = ({
  onSave,
  saving,
}) => {
  const dispatch = useDispatch();

  const expectedVolumesByRoutePair = useSelector(selector);

  const onClickDiscard = () => {
    dispatch(expectedVolumeTableReset());
  };

  const canSave = useMemo(() => {
    const r = getExpectedVolumeChanges(expectedVolumesByRoutePair);
    return r.length > 0;
  }, [expectedVolumesByRoutePair]);

  usePrompt({
    message: "You have unsaved changes, would you like to leave the page?",
    shouldBlock: canSave,
  });

  return (
    <Row alignItems={"center"}>
      {saving && <LoadingModalWithLock label={"Saving expected volumes..."} />}

      <Indent />
      <SecondaryButton
        label={"Discard"}
        onClick={onClickDiscard}
        disabled={!canSave || saving}
      />
      <Indent />
      <PrimaryButton
        label={"Save"}
        disabled={!canSave}
        onClick={onSave}
        loading={saving}
      />
    </Row>
  );
};
